/**
 * InsertLearning
 *
 * Declares a single web-accessible-resource entry (`lib/fonts/*`, `lib/iframe/*`,
 * `lib/img/*`) matched to every origin with no `use_dynamic_url` — so its icons, iframe
 * assets and fonts are all fetchable from any page at a fixed URL.
 *
 * The icons under lib/img are the cleanest signal: being images they load through
 * `probeImage` with no CORS grant, so they survive a restrictive page CSP.
 *
 * Manifest verified against version 2.2.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dehajjkfchegiinhcmoclkfbnmpgcahj';

export const insertlearning: ExtensionDefinition = {
  id: ID,
  name: 'InsertLearning',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes lib/fonts, lib/iframe and lib/img to every origin with no dynamic URL. ' +
    'The bundled icons are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-icon-image',
      kind: 'web-accessible-resource',
      description:
        'Load lib/img/icon.png via <img> — a bundled icon exposed to every origin; ' +
        'needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'lib/img/icon.png'),
    },
    {
      id: 'war-iframe-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch lib/iframe/iframe.js — the injected sidebar iframe script exposed as a ' +
        'static WAR.',
      weight: 0.5,
      run: () => probeFetch(ID, 'lib/iframe/iframe.js'),
    },
    {
      id: 'war-iframe-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch lib/iframe/iframe.css — the iframe stylesheet, a third path independent ' +
        'of the icon and iframe script.',
      weight: 0.5,
      run: () => probeFetch(ID, 'lib/iframe/iframe.css'),
    },
  ],
};
